module.exports = __webpack_public_path__ + "static/media/editing_icon.b3a02829.jpeg";